(function () {
  'use strict';

  var ANFANG = 0.25;
  var ENDE = 0.6;

  function behaelterSuchen(el) {
    for (var p = el.parentElement; p; p = p.parentElement) {
      var art = getComputedStyle(p).overflowY;
      if ((art === 'auto' || art === 'scroll') && p.scrollHeight > p.clientHeight) {
        return p;
      }
    }
    return null;
  }

  function einrichten(abschnitt) {
    if (abschnitt.dataset.oeBereit) return;
    abschnitt.dataset.oeBereit = '1';

    var SCHRITTE = abschnitt.querySelectorAll('.oe-buehne__bild').length || 2;
    var zahlen = [].slice.call(abschnitt.querySelectorAll('[data-von]'));
    var behaelter = behaelterSuchen(abschnitt);
    var offen = false;

    function rechnen() {
      offen = false;
      var kasten = abschnitt.getBoundingClientRect();
      var sichtOben, sichtHoehe;
      if (behaelter) {
        var b = behaelter.getBoundingClientRect();
        sichtOben = b.top;
        sichtHoehe = b.height;
      } else {
        sichtOben = 0;
        sichtHoehe = window.innerHeight || document.documentElement.clientHeight;
      }

      var weg = sichtHoehe + kasten.height;
      var anteil = (sichtHoehe - (kasten.top - sichtOben)) / weg;

      var q = (anteil - ANFANG) / (ENDE - ANFANG);
      if (q < 0) q = 0;
      if (q > 1) q = 1;

      var schritt = Math.floor(q * SCHRITTE) + 1;
      if (schritt > SCHRITTE) schritt = SCHRITTE;

      if (abschnitt.dataset.schritt !== String(schritt)) {
        abschnitt.dataset.schritt = String(schritt);
        for (var i = 0; i < zahlen.length; i++) {
          var z = zahlen[i];
          var von = +z.dataset.von;
          var bis = +z.dataset.bis;
          z.classList.toggle('oe-rolle__zahl--da', schritt >= von && schritt <= bis);
          z.classList.toggle('oe-rolle__zahl--weg', schritt > bis);
        }
      }
    }

    function anstossen() {
      if (offen) return;
      offen = true;
      requestAnimationFrame(rechnen);
    }

    (behaelter || window).addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen, { passive: true });
    abschnitt.classList.add('oe-stufen--bereit');
    rechnen();
  }

  function start() {
    var abschnitte = document.querySelectorAll('[data-oe-stufen]');
    for (var i = 0; i < abschnitte.length; i++) einrichten(abschnitte[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
